@import '~style-sheet-helpers/core.less';
@import '../../app-brand/entities/entity-layer.module.less';
@import '../../constants/spacing.module.less';
@import '../../constants/screen-width-breakpoints.module.less';

.flex-column {
  display: flex;
  flex-direction: column;
}

.xl-font {
  font-size: 28px;
  line-height: 35px;
}

.large-font {
  font-size: 16px;
}

.normal-font {
  font-size: 14px;
}

.small-font {
  font-size: 12px;
  line-height: 18px;
}

.onboard-page {
  height: 100%;
  overflow-y: auto;
}

.onboarding-background {
  width: 100%;
  background-color: @onboarding-page--container--background-color;
  background-image: url('../bg--cubes.svg');
  background-size: 500px;
  background-repeat: no-repeat;
  background-position: right 0 top -45px;

  @media @tablet, @desktop, @widescreen, @ultrawide {
    .flex-column();
    justify-content: flex-start;
    align-items: center;
  }
}

.onboarding-container {
  max-width: 928px;
  width: 100%;
  .normal-font();
  box-shadow: 0 12px 24px @onboarding-page--box-shadow;
  border-radius: 4px;
  margin: 0;
  padding: 0;

  @media @tablet, @desktop, @widescreen, @ultrawide {
    background-color: @onboarding-page--container--background-color;
    margin: 58px 0 24px;
    padding: 40px 32px;
  }
}

.explore-add-ons-container {
  margin-top: @space-0;
  padding: @space-24 @space-24 @space-24 @space-24;

  @media @mobile {
    margin-top: @space-16;
    background-color: var(--onboarding-page--container--background-color);
  }
}

.onboarding-header-container {
  text-align: center;
  color: @onboarding-page--text-color;
  padding: 32px 24px;

  @media @tablet, @desktop, @widescreen, @ultrawide {
    text-align: center;
    padding: 0;
    margin: 0 0 40px;
  }

  h1 {
    margin: 0 0 12px;
    font-weight: @semi-bold;
    .xl-font();
  }

  p {
    color: @onboarding-page--description--text-color;
    line-height: 21px;
  }
}

.steps-container {
  .flex-column();
  row-gap: 16px;

  @media @mobile {
    background-color: @onboarding-page--background-color;
  }
}

.onboarding-footer-container {
  max-width: 928px;
  width: 100%;
  color: @onboarding-page--text-color;
  display: flex;
  justify-content: flex-end;
}

.onboarding-footer-wrapper {
  text-align: left;
  padding: 24px;

  @media @tablet, @desktop, @widescreen, @ultrawide {
    width: 50%;
    text-align: right;
    padding: @space-0 @space-32 @space-16 @space-0;
  }
}

.hide-page-action {
  margin-bottom: @space-4;
  font-weight: @normal;
  .normal-font();
  line-height: 21px;
  text-align: right;
  &:hover {
    text-decoration: none;
  }
  &:focus {
    background: none;
  }
}

.footer-message {
  .small-font();
  margin: 0;
}

.icon {
  width: 16px;
  height: 16px;
  fill: var(--grey-700);
  margin-left: 2px;
}
